export function isPoint(value) {
  if (
    Array.isArray(value) &&
    value.length === 3 &&
    typeof value[0] === "number" &&
    typeof value[1] === "number" &&
    typeof value[2] === "number"
  ) {
    return true;
  } else {
    return false;
  }
}

export function isArray(value) {
  return value && Array.isArray(value) && !isPoint(value);
}

function analyzeValues(inputValues) {
  return Object.keys(inputValues).reduce(
    (acc, property) => {
      const value = inputValues[property];
      if (!isArray(value)) return acc;
      return {
        ...acc,
        longestList:
          (inputValues[acc.longestList]?.length || 0) <= value.length
            ? property
            : acc.longestList,
        hasArrays: true,
      };
    },
    {
      longestList: "",
      hasArrays: false,
    }
  );
}

function getArrayValues({ inputValues, inputs }) {
  return Object.keys(inputValues).reduce((acc, key) => {
    const acceptsList = inputs.find((i) => i.id === key).list;
    return acceptsList ? { ...acc, [key]: inputValues[key] } : acc;
  }, {});
}

function findLongestArray(inputs, keys) {
  let length = 0;
  let longestKey = "";

  keys.forEach((key) => {
    const inputLength = inputs[key]?.length || 0;
    if (inputLength >= length) {
      length = inputLength;
      longestKey = key;
    }
  });

  return longestKey;
}

export function createComponent(component) {
  return {
    ...component,
    outputs: component.outputs.map((output) => {
      return {
        ...output,
        compute: (inputs, controls) => {
          const inputsWithLists = component.inputs
            .filter((i) => i.list === true)
            .map((i) => i.id);
          const needsToIterate = Object.keys(inputs).some(
            (key) => isArray(inputs[key]) && !inputsWithLists.includes(key)
          );

          if (!needsToIterate) {
            return output.compute(inputs, controls);
          }

          if (needsToIterate) {
            const inputArraysToIterate = Object.keys(inputs).filter(
              (key) => isArray(inputs[key]) && !inputsWithLists.includes(key)
            );
            const longestArray = findLongestArray(inputs, inputArraysToIterate);

            return inputs[longestArray].map((value, index) => {
              const reducedInputs = Object.keys(inputs).reduce((acc, key) => {
                const value = inputs[key];

                const acceptsList = inputsWithLists.includes(key);

                if (acceptsList) {
                  return { ...acc, [key]: isArray(value) ? value : [value] };
                }

                return {
                  ...acc,
                  [key]: isArray(value)
                    ? value[index] || value[value.length - 1]
                    : value,
                };
              }, {});

              return output.compute(reducedInputs, controls);
            });
          }
        },
      };
    }),
  };
}
